"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const arrow_up_1 = require("../icons/arrow-up");
exports.default = arrow_up_1.ArrowUp;
